import { render, staticRenderFns } from "./CoverDesign.vue?vue&type=template&id=3cb9017f&scoped=true&"
import script from "./CoverDesign.vue?vue&type=script&lang=js&"
export * from "./CoverDesign.vue?vue&type=script&lang=js&"
import style0 from "./CoverDesign.vue?vue&type=style&index=0&id=3cb9017f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9017f",
  null
  
)

export default component.exports